import { useState } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { SetupDialogPreview } from "./SetupDialogPreview";

interface DevToolsProps {
  onTriggerError: () => void;
}

export function DevTools({ onTriggerError }: DevToolsProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  useHotkeys("mod+shift+period", () => setIsVisible((v) => !v), {
    preventDefault: true,
  });

  if (!isVisible) return null;

  return (
    <>
      <div className="fixed bottom-4 left-4 z-50 flex gap-2">
        <button
          onClick={() => setShowPreview(true)}
          className="px-2 py-1 text-xs font-mono rounded bg-(--color-bg-muted) border border-(--color-border) text-(--color-text-muted) hover:text-(--color-text) hover:border-(--color-text-muted)"
        >
          preview states
        </button>
        <button
          onClick={onTriggerError}
          className="px-2 py-1 text-xs font-mono rounded bg-red-500/10 border border-red-500/30 text-red-500 hover:bg-red-500/20 hover:border-red-500/50"
        >
          trigger error
        </button>
      </div>
      {showPreview && (
        <SetupDialogPreview onClose={() => setShowPreview(false)} />
      )}
    </>
  );
}
